<template>
  <div id="ExhpredictionEdit_ENG">
    <div class="main-container" v-loading="this.loading" element-loading-text="loading">
     
      <!--审核状态-->
      <div id="remark" v-if="baseInforForm.sjzt == '04'">
        <el-row>
          <el-col :span="1" style="text-align: center">
            <i class="icon-alarm"></i>&nbsp;</el-col>
          <el-col :span="6" style="text-align: left">Last Approval Status:&nbsp;&nbsp;Reject</el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="16" style="text-align: left">Reason:&nbsp;&nbsp;
            <span v-text="baseInforForm.reserve1"></span>
          </el-col>
        </el-row>
      </div>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="collapseicon el-icon-document"></i> Brief Company Information
          </template>
          <div id="inforView" class="pt15" >
            <baseInfo ref="baseInfo" v-on:getLoading="getLoading" v-on:getbaseInforData="getbaseInforData" v-on:getQyid="getQyid" v-on:getActive="getActive" v-bind:qyid="qyid"></baseInfo>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="collapseicon el-icon-printer"></i> Invoice Information
          </template>
          <div id="kpxxView" class="pt15" >
            <kpxx ref="kpxx" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid" v-bind:baseInforForm="baseInforForm"></kpxx>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
           <template slot="title">
            <i class="collapseicon el-icon-edit-outline"></i> Major Product Information
          </template>
          <div id="wjdcView" class="pt15">
            <wjdc ref="wjdc" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></wjdc>
          </div>
        </el-collapse-item>
        
        <el-collapse-item name="5">
          <template slot="title">
            <i class="collapseicon el-icon-setting"></i> Company and Product Details
          </template>
          <div id="cpjsView" class="pt15" >
            <cpjs ref="cpjs" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></cpjs>
          </div>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <i class="collapseicon el-icon-star-on"></i> Questionnaire on your Booth Requirement
          </template>
          <div id="xqyxView" class="pt15" >
            <xqyx ref="xqyx" v-on:getLoading="getLoading" v-on:getActive="getActive" v-bind:qyid="qyid"></xqyx>
          </div>
        </el-collapse-item> 
      </el-collapse>
      
      <el-row class="buttonSubmit" v-if="this.userType == 'ZSYH'">
        <el-col :span="24">
          <el-button type="primary" icon="el-icon-check" size="small" @click="submit()" 
          style="width:120px; height: 40px;">Submit</el-button>
        </el-col>
      </el-row>
      
    </div>
  </div>
</template>

<script>
import baseInfo from '@/views/exhibition/prediction/exhprediction/exhpredictionEditEng/BaseInfo'
import kpxx from '@/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Kpxx'
import wjdc from '@/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Wjdc'
import cpjs from '@/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Cpjs'
import xqyx from '@/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Xqyx'

export default {
  components: {
    baseInfo,
    kpxx,
    wjdc,
    cpjs,
    xqyx
  },
  name: "ExhpredictionEdit_ENG",
  data() {
    return {
      baseInforForm:{},
      activeNames:['6'],
      //当前用户
      currentUser: this.CONSTANT.currentUser,


      
      userType: this.CONSTANT.currentUser.deptid,
      baseUrl: window.config.baseUrl,
      
      //菜单编码
      activeIndex: "",
      //显示加载中样
      loading: false,
      
     
      //企业id
      qyid: "",
    
      //企业介绍uuid
      qyUuid: "",
      //需求意向uuid
      xqUuid: "",
      
      //进度条
      active: 0,
      //要删除的图片路径list
      delPicList: [],
      delPicSrc: "",
      //上传后未保存的图片list
      unsavedPicList: [],
      fileList: [],
      //曾用公司名称
      cygsmc: "",
     
      
      
      

      //需求意向表单
      xqyxForm: {},
      
      //开票信息显示标识
      isKpxxShow: false,
      //问卷调查显示标识
      isWjdcShow: false,
      //企业和产品介绍显示标识
      isCpjsShow: false,
      //企业参展展位需求意向
      isXqyxShow: false,
      //问卷调查产品类型选择标识
      isCplxSelect: false,
      //手机验证表单显示标识
      //dialogSjFormVisible:false,
     

      //是否为已驳回的申请
      isYbh: false,
      
      //产品index
      index: 0,
      //树结构配置
      defaultProps: {
        children: "children",
        label: "codeName",
        value: "codeValue"
      },
      //上传图片Data
      fileList: [],
      
      //上传logo加参数
      upLoadLogoData: {
        uuid: "",
        qyid: ""
      },
      //产品图片上传参数
      CpjsUpLoadData: {
        qyid: ""
      },
      //公司logo
      imageUrl: "",
      
      
      
     
    };
  },
  created: function() {
    //获取qyid
   if (this.userType == "ZSYH") {
      //展商
      this.doSearchQyidByUserid(this.currentUser.userid);
    } else {
      //管理员
      this.doSearchQyidByUserid(this.$route.query.id);
    }




    // if (this.currentUser.deptid == "ZSYH") {
    //   //展商
    //   this.findInfoByUserid(this.currentUser.userid);
    //   this.checkPasswordChg();
    // } else {
    //   //管理员
    //   //modify by yushch 20200407 管理端选择展商，新增时自动带入邮箱
    //   var type = this.$route.query.type;
    //   if(type == 'XZ'){
    //     this.baseInforForm.email = this.$route.query.username;
    //     this.baseInforForm.userid = this.$route.query.userid;
    //   }else{
    //     this.findInfoByQyid(this.$route.query.id);
    //   }
    // }
  },
  mounted: function() {
    
  },
  methods: {
    //通过userid查询qyid
    doSearchQyidByUserid: function(userid){
      let vm = this;
      let params={
        userid:userid,
        deleteFlag: "N"
      }
      vm.$axios.post("/qyjbxx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            vm.qyid = res.data.result[0].qyid;
          }else{
            vm.qyid = 'newInsert'
            vm.activeNames = ['1']
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },

    //add by yushch 20220929
    getLoading(loading){
      this.loading = loading;
    },
    getbaseInforData(data){
      this.baseInforForm = data;
    },
    getQyid(qyid){
      this.qyid = qyid;
    },
    getActive(active){
      this.active = active;
    },


    //提交
    submit: function() {
      let vm = this;
      vm.loading = true;
      vm.$axios.get("/qyjbxx/checkInfoComplete/" + vm.qyid).then(
        function(res) {
          if (res.data.code == "00000000") {
            vm.loading = false;
            if (this.currentUser.deptid == "ZSYH") {
              //如果是展商用户跳转到确认页
              this.$router.push({name:"exhpredictionConfirm", query: {userid: this.currentUser.userid, type: 'BJ'}});
            } else {
              //如果是管理员跳转到列表页
              this.$router.push({name:"exhprediction"});
            }
          }else if (res.data.code == "99999999") {
            var msg = res.data.msg;

            vm.$alert(
              'Plase fill in and save :<Strong style="color:#000">' +
                msg +
                "</Strong>！",
              "Info",
              { dangerouslyUseHTMLString: true }
            );
            vm.loading = false;
          } else {
            vm.loading = false;
            vm.$message.error(res.data.msg);
          }
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );






      
    },

    checkPasswordChg: function(){
      let vm = this;
      var passwordChgFlag = vm.currentUser.passwordChgFlag;
      if (passwordChgFlag == "F") {
        vm.$alert(
          'In order to ensure the security of personal information, please click on the "Welcome! - user center" and change your password as soon as possible.',
          'Message',
          {
            confirmButtonText: 'confirm',
            type: 'warning'
          });
      }
    }
  }
};
</script>

<style lang="scss">
#ExhpredictionEdit_ENG {
  #qycpArea .el-form-item__error {
    padding-top: 8px !important;
  }
  #cp_card .el-card__header {
    padding: 1px 15px;
  }
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }
  .yxLabel {
    text-align: right;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    font-weight: 700;
    max-width: 100%;
    margin-bottom: 5px;
  }
  #cplx_btn_group {
    margin-bottom: 10px;
  }
  #cplx_btn_group .el-button--small {
    margin-right: 10px;
  }
  #cplx_btn_group .el-button + .el-button {
    margin-left: 0;
  }
  #cplx_chb_group .el-checkbox {
    margin-right: 30px;
  }
  #cplx_chb_group .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
  #cplx_btn_group .el-form-item__error {
    padding-top: 8px;
  }
  #tagCheckbox .el-checkbox__label {
    padding-left: 5px;
    font-size: 10px;
  }
  #remark {
    line-height: 31px;
    padding: 5px 15px;
    border: 1px solid #e40613;
    border-radius: 5px;
    color: #e40613;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  #remark i.icon-alarm {
    width: 28px;
    height: 25px;
    display: inline-block;
    margin-bottom: -5px;
    background: url("/static/images/prediction/alarm.png") no-repeat;
    background-size: cover;
  }
  #cpjsArea .el-form-item__error {
    padding-top: 8px;
  }
  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  .collapseicon{
    margin :0 10px 0 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/ExhpredictionEdit_ENG.vue